import jwtDecode from "jwt-decode";

export function checkJwtToken() {
  // check if set
  if (!localStorage.getItem("token")) {
    return false;
  }
  let token = localStorage.getItem("token");
  let decoded;
  try {
    decoded = jwtDecode(token);
  } catch (e) {
    console.error("Could not authenticate");
    return false;
  }
  if (!decoded) {
    return false;
  }
  let valid;
  if (Date.now() < decoded.exp * 1000) {
    valid = true;
  }
  if (!valid) {
    return false;
  }
  return decoded;
}
